export const toSnakeCase = (str: string) => {
  return str
    .replace(/\s+/g, '_')
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toLowerCase();
};

export const STANDARD_ACTIONS = ['create', 'read', 'update', 'delete'];
